import { create } from "zustand";

export const useHoverStore = create<{
  hoveredDate: Date | null;
  setHoveredDate: (date: Date | null) => void;
}>((set) => ({
  hoveredDate: null as Date | null,
  setHoveredDate: (date: Date | null) => set({ hoveredDate: date }),
}));
